import { UserRole } from "../../../../types/userProfile";
import type { Facts } from "../checks/buildFacts";

export function canShowOuterDeactivate(facts: Facts): boolean {
  const { role} = facts;

  if (role === UserRole.Admin) return true;

  return false;
}
